import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SessionStorageService } from 'ngx-webstorage';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { HomeService } from 'src/app/modules/home/home.service';
import { IResponse } from 'src/app/shared/models/app';
import { MobileDialogData } from '../../common';

@Component({
    selector: 'nphs-user-application-alert',
    templateUrl: './application-alert.component.html',
    styleUrls: ['./application-alert.component.scss'],
    standalone: false
})
export class ApplicationAlertComponent implements OnInit {

  appMaintenanceObj:any={};
  releaseNoteFlag = false;
  isReleaseNoteAvailable = false;

  constructor(private storage:SessionStorageService,public dialog: MatDialogRef<ApplicationAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogdata,
    public dialogRef: MatDialog,
    private homeService:HomeService) { }

  ngOnInit(): void {
    this.appMaintenanceObj = this.dialogdata.appMaintenanceObj;
    this.isReleaseNoteAvailable = this.dialogdata.isReleaseNoteAvailable;
  }

  closeMaintenanceBanner(){
    this.appMaintenanceObj.activeFlag = false;
    this.storage.store(
      CacheConstant.SessionStorageData.NuctracAppMaintenance,
      this.appMaintenanceObj
    );
    this.dialog.close();
  }

  dismissMaintenanceBanner(){
    this.appMaintenanceObj.activeFlag = false;
    this.storage.store(
      CacheConstant.SessionStorageData.NuctracAppMaintenance,
      this.appMaintenanceObj
    );
    let userId = this.storage.retrieve(CacheConstant.SessionStorageData.LoggedInUserID);
    this.homeService.dismissMaintenanceAlert(this.appMaintenanceObj.appMaintenanceNum,userId).subscribe((response:IResponse)=>{
    });
    this.dialog.close();
  }

  showReleaseNotes() {
    this.releaseNoteFlag = !this.releaseNoteFlag;
  }

}
